import { ApiService } from '@/api/services/core/ApiService';
import { axiosExternalInstance } from '@/api/axios';
import moment from 'moment';

export class InternalService extends ApiService {
  public testTaxDay() {
    const date = moment().format('YYYY-MM-DD');
    return axiosExternalInstance.get<any>(
      `/api/internal/tests/tax/day?date=${date}`
    );
  }

  public testTaxMonth() {
    const date = moment().format('YYYY-MM-DD');
    return axiosExternalInstance.get<any>(
      `/api/internal/tests/tax/month?date=${date}`
    );
  }
}
